export default __webpack_public_path__ + "static/media/childstory.f8121a80.svg";